var map = {
	"./boring.svg": 4294,
	"./brain.svg": 935,
	"./cheese.svg": 8470,
	"./crown.svg": 7086,
	"./frozen.svg": 3267,
	"./handshake.svg": 9688,
	"./money.svg": 7767,
	"./palm.svg": 2741,
	"./peacock.svg": 817,
	"./repair.svg": 6010,
	"./star.svg": 4265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3901;